import styled from "styled-components";

export const Container = styled.button`
  align-items: center;
  background-color: #fa821f;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  font-size: 18px;
  justify-content: center;
  height: 48px;
  margin: 10px auto;
  width: 250px;
`;
